// ─── Filtro "Concluídos da semana atual" (Seg-Dom) ─────────────────────────────
// Usado pelas telas de Processos Internos RH e Candidatos para pré-filtrar a
// seção Concluídos por padrão (chip removível).

/** Retorna o intervalo da semana atual (Segunda a Domingo, horário local). */
export const getCurrentWeekRange = (): { startDate: Date; endDate: Date } => {
  const today = new Date();
  // getDay(): 0=Dom, 1=Seg, ..., 6=Sáb. (Dom pertence à semana que começou na Seg anterior.)
  const diffToMonday = (today.getDay() + 6) % 7;
  const monday = new Date(today);
  monday.setDate(today.getDate() - diffToMonday);
  monday.setHours(0, 0, 0, 0);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  sunday.setHours(23, 59, 59, 999);
  return { startDate: monday, endDate: sunday };
};

/** Formato YYYY-MM-DD (local, sem deslocamento de fuso) — para query params. */
export const toYmd = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/** Formato DD/MM — para exibição no chip. */
export const toDm = (d: Date): string =>
  `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}`;